let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("tksIc")).then(() => parcelRequire('7Jiwh'));